<div class="change-title mfp-white-box">
  <img
    mfpLazyImage
    class="change-title__close"
    lazySrc="assets/icons/close.svg"
    (click)="onClose()"
  />
  <h1 class="change-title__title">{{ title }}</h1>
  <form class="change-title__form">
    <mfp-input
      view="agent"
      name="name"
      type="text"
      [label]="'LIFE_PLANS.MODALS.CHANGE_TITLE.TITLE' | translate"
      [placeholder]="'LIFE_PLANS.MODALS.CHANGE_TITLE.TITLE_PLACEHOLDER' | translate"
      [required]="true"
      [readonly]="false"
      [success]="!!lifePlanTitle"
      [error]="lifePlanTitleTouched && !lifePlanTitle"
      [helper]="lifePlanTitleTouched && !lifePlanTitle ? ('FORMS.MANDATORY_FIELD' | translate) : ''"
      [ngModel]="lifePlanTitle"
      (ngModelChange)="onChangeTitle($event)"
    ></mfp-input>
  </form>
  <div class="change-title__divider"></div>
  <div class="change-title__actions">
    <mfp-button
      class="change-title__button change-title__button-first"
      type="button"
      color="primary"
      fill="outline"
      [label]="cancelAction"
      [disabled]="false"
      (click)="onClose()"
    ></mfp-button>
    <mfp-button
      class="change-title__button"
      type="button"
      color="primary"
      [label]="successAction"
      [disabled]="false"
      (click)="onAccept()"
    ></mfp-button>
  </div>
</div>
